module.exports = require("./ar-LY");